import React, { useState } from "react";
import { Button, TextField } from "@material-ui/core";
import useStyles from "../../components/Common/styles";
import SaveIcon from "@material-ui/icons/Save";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Blade, BladeValidationDisplay } from "../../components/Common/Blade";
import { toastr } from "../../components/Common/toastr";
import useProtectApi from "../../hooks/useProtectApi";

const CurrencyCreate = () => {
	const classes = useStyles();
	const { register, handleSubmit, errors } = useForm();
	const history = useHistory();
	const dispatch = useDispatch();

	const currencyCreateApi = useProtectApi("currency/create");

	const [createErrors, setCreateErrors] = useState();
	const [isBusy, setIsBusy] = useState(false);

	const onSubmit = async (data) => {
		var request = {
			name: data.name,
			code: data.code,
			symbol: data.symbol,
		};

		const createCurrency = () =>
			currencyCreateApi.api().then((w) =>
				w
					.post(request)
					.badRequest((err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setCreateErrors(errDetail);
						throw new Error(errDetail);
					})
					.error(409, (err) => {
						console.log(err);
						var errDetail = JSON.parse(err.text).detail;
						setCreateErrors(errDetail);
						throw new Error(errDetail);
					})
					.json((json) => {
						var newCurrency = {
							...request,
							id: json.id,
							code: data.code,
							symbol: data.symbol,
						};

						dispatch({
							type: "CREATE_CURRENCY",
							payload: newCurrency,
						});

						return newCurrency;
					})
					.then(() => toastr.success("Currency created!"))
					.then(() => closeDrawer())
					.catch((error) => {
						console.log(error);
						toastr.error("Unable to create new Currency.");
					})
					.finally(() => setIsBusy(false))
			);

		setIsBusy(true);
		createCurrency();
	};

	const closeDrawer = () => {
		history.push("/currencies");
	};

	return (
		<Blade title="Create New Currency">
			<div>
				<form onSubmit={handleSubmit(onSubmit)}>
					<section name="Name">
						<TextField
							label="Name *"
							fullWidth
							autoFocus
							name="name"
							error={!!(errors && errors.name)}
							style={{ marginBottom: 16 }}
							autoComplete="off"
							inputRef={register({
								required: {
									value: true,
									message: "Name is required",
								},
								maxLength: {
									value: 255,
									message: "Name is too long",
								},
							})}
							inputProps={{
								"aria-label": "Name",
							}}
							helperText={errors && errors.name && errors.name.message}
						/>
					</section>

					<section name="Code">
						<TextField
							label="Code *"
							fullWidth
							name="code"
							error={!!(errors && errors.name)}
							style={{ marginBottom: 16 }}
							autoComplete="off"
							inputRef={register({
								required: {
									value: true,
									message: "Code is required",
								},
								maxLength: {
									value: 3,
									message: "Code must be 3 characters in length",
								},
								minLength: {
									value: 3,
									message: "Code must be 3 characters in length",
								},
							})}
							inputProps={{
								"aria-label": "Code",
							}}
							helperText={errors && errors.code && errors.code.message}
						/>
					</section>

					<section name="Symbol">
						<TextField
							label="Symbol *"
							fullWidth
							name="symbol"
							error={!!(errors && errors.symbol)}
							style={{ marginBottom: 16 }}
							autoComplete="off"
							inputRef={register({
								required: {
									value: true,
									message: "Symbol is required",
								},
								maxLength: {
									value: 3,
									message: "Symbol must be maximum 3 characters in length",
								},
							})}
							inputProps={{
								"aria-label": "Symbol",
							}}
							helperText={errors && errors.symbol && errors.symbol.message}
						/>
					</section>

					{!!createErrors && <BladeValidationDisplay validationErrors={createErrors} />}

					<div className={classes.drawerBladeToolbar}>
						<Button
							variant="contained"
							color="primary"
							size="medium"
							type="submit"
							className={classes.button}
							endIcon={<SaveIcon />}
							disabled={isBusy}>
							SAVE
						</Button>
					</div>
				</form>
			</div>
		</Blade>
	);
};
export default CurrencyCreate;
